import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'

interface TopRankingWrapperProps {
  children: ReactNode
  topBar?: string
  additionalClassName?: string
}

export function TopRankingWrapper(props: TopRankingWrapperProps): ReactElement {
  if (props.topBar) {
    return (
      <div
        className={classNames(
          'flex flex-col overflow-hidden rounded-md px-[3px] pb-[3px]',
          props.additionalClassName,
          {
            'bg-primary-lightened': props.topBar,
          },
        )}
      >
        <div className="text-secondary-text-color mx-2 h-8 truncate pb-1 pt-1 text-sm font-semibold">
          {props.topBar}
        </div>
        {[props.children]}
      </div>
    )
  }

  return <>{props.children}</>
}
